import React, { Component } from "react";
import CryptoJS from "crypto-js";
import { withRouter } from "react-router-dom";
import AuthService from "../../session/AuthService";
import FarmShopConnectLogo from "../../images/FarmShopConnectLogo.png";
import LoginService from "../../api/LoginService";
import { Toaster, toast } from "react-hot-toast";
import { ContentPasteSearchOutlined } from "@mui/icons-material";
import { Col, Row } from "react-bootstrap";
import playstore from "../../images/playstore.png";
import appstore from "../../images/appstore.png";
// import { VscRunErrors } from "react-icons/vsc";

class Nosubscription extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <div className="login-page">
          <div className="logo-container">
            <img src={FarmShopConnectLogo} alt="Logo" className="logo" />
          </div>
          <div className="login-card">
            <Row className="p-2">
              <Col xs={12}>
                <h5 style={{ fontWeight: 700, color: "#292929" }}>
                  No Active Subscription
                </h5>
                <p className="my-2" align="left">
                  It appears that you do not have an active subscription, or
                  your current subscription has expired. Please subscribe or
                  renew your subscription to continue using the service.
                </p>
              </Col>
              <Col
                xs={6}
                className="d-flex align-items-center justify-content-center"
              >
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/in/app/farm-shop-connect/id6470219426"
                >
                  <img
                    src={appstore}
                    alt="Download on App Store"
                    className="responsive-ref-ios"
                    loading="lazy"
                  />
                </a>
              </Col>
              <Col
                xs={6}
                className="d-flex align-items-center justify-content-center"
              >
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.farmshopconnect.mobileapp"
                >
                  <img
                    src={playstore}
                    alt="Download on Play Store"
                    className="responsive-ref-android"
                    loading="lazy"
                  />
                </a>
              </Col>
            </Row>
          </div>
        </div>
        <Toaster />
      </>
    );
  }
}

export default withRouter(Nosubscription);
